{
  "version": 1,
  "asset_id": "d84f784a-4fdc-488d-a163-14d00ac7e81d",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/d84f784a-4fdc-488d-a163-14d00ac7e81d/lpgas-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/d84f784a-4fdc-488d-a163-14d00ac7e81d/lpgas-card.webp",
  "original_filename": "lpgas-card.webp",
  "size": 17322,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:03Z"
}
